 
import './App.css';
import MainComponents from './MainComponents';

import React from 'react';

function App() {
  return (
<div className=''>

      <MainComponents/>
      {/* <AnnouncementBar/> */}
      </div>
  
  );
}

export default App;
 